import { createCommunicationEventCreator } from '@ac/library-utils/dist/communication/event-bus';

export const mobileAppServiceWorkerUpdatedEvent =
  createCommunicationEventCreator('mobileAppContainer_serviceworkerUpdated');
